import React from 'react';
import CustomPhoneNoView from '../../../../../shared/custom-PhoneNoView/CustomPhoneNoView';
import RedirectUrlLink from '../../../../../shared/redirect-url-link/Redirect-Url-Link';
import CustomView from '../../CustomView';

const ContactView = ({ restaurantContact = [] }) => {
  const contact0 = restaurantContact[0];

  const contact1 = restaurantContact[1];

  const noContactDetails =
    restaurantContact.length > 0 &&
    !contact0?.value1 &&
    !contact0?.value2 &&
    (!contact1?.information || contact1.information.length === 0);

  if (noContactDetails) {
    return (
      <div className='row mx-4 mt-4'>
        <div className='col-md-12'>
          <div className='details-label'>No contact details available</div>
        </div>
      </div>
    );
  }

  return (
    <>
      {restaurantContact.map((restroDetail) => (
        <CustomView
          key={restroDetail.id}
          type={restroDetail.type}
          value1={restroDetail.value1}
          value2={<CustomPhoneNoView value={restroDetail.value2} />}
          name1={restroDetail.name1}
          name2={restroDetail.name2}
        />
      ))}

      {contact1?.information?.length > 0 && (
        <div className='row mx-4 mt-4'>
          <div className='col-md-12'>
            <div className='details-label'>Information</div>
          </div>
          <div className='col-md-12'>
            {contact1.information.map((val, ndx) => (
              <div key={ndx} className='details-value'>
                <div>
                  {val.reviewerTitle} - {val.displayTitle}
                </div>
                <div>
                  <RedirectUrlLink url={val.URL} />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default ContactView;